var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaveCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8516,
    cy: 10.9595,
    r: 10,
    fill: "#35475D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.5555 7.2085H11.3311V9.24931H12.5555V7.2085Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8645 6.18799H5.8208V16.188H15.6167V7.94023L13.8645 6.18799ZM7.86162 6.59615H13.1677V9.86146H7.86162V6.59615ZM13.78 15.7798H7.45345V11.4941H13.78V15.7798Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47361 12.7187H9.90218C10.015 12.7187 10.1063 12.6275 10.1063 12.5146C10.1063 12.4018 10.015 12.3105 9.90218 12.3105H8.47361C8.36076 12.3105 8.26953 12.4018 8.26953 12.5146C8.26953 12.6275 8.36076 12.7187 8.47361 12.7187Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47361 13.5349H10.5144C10.6273 13.5349 10.7185 13.4436 10.7185 13.3308C10.7185 13.2179 10.6273 13.1267 10.5144 13.1267H8.47361C8.36076 13.1267 8.26953 13.2179 8.26953 13.3308C8.26953 13.4436 8.36076 13.5349 8.47361 13.5349Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1269 13.535C11.182 13.535 11.2331 13.5126 11.2718 13.4758C11.3086 13.437 11.331 13.384 11.331 13.3309C11.331 13.2779 11.3086 13.2246 11.2718 13.186C11.1963 13.1105 11.0596 13.1105 10.9841 13.186C10.9453 13.2246 10.9229 13.2756 10.9229 13.3309C10.9229 13.386 10.9451 13.437 10.982 13.4758C11.0206 13.5126 11.0716 13.535 11.1269 13.535Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(5.71875 6.18799)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveCircle);
export default __webpack_public_path__ + "static/media/save_circle.8ce0774b3d21f54953fe6587a3d6d50b.svg";
export { ForwardRef as ReactComponent };